import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App.tsx";
import { ErrorBoundary } from "./components/ErrorBoundary.tsx";
import { applyAccent, loadAccent } from "./lib/accentColor.ts";

// index.html's inline script already set data-accent before paint (for a
// non-default scheme, to avoid a flash); this additionally syncs the
// <meta name="theme-color"> tag, which that tiny inline script can't do
// without duplicating the per-scheme color table.
applyAccent(loadAccent());

// The service worker (registerType: "autoUpdate") activates a new version
// in the background via skipWaiting/clientsClaim, but an already-open tab
// has no way to know its in-memory JS is now stale — reload once when a new
// worker takes control so a new deploy doesn't need a manual site-data clear.
if ("serviceWorker" in navigator) {
  let reloadedForUpdate = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (reloadedForUpdate) return;
    reloadedForUpdate = true;
    window.location.reload();
  });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>
);
